import * as React from 'react'
import { QuickActionResult } from '../../../../common/src/types.gen'
import CrossSellSearchModal, { CrossSellOption } from './CrossSellSearchModal'

export type QAComposerData =
  | {
      type: 'CROSS_SELL_SEARCH'
      crossSellOptions: CrossSellOption[]
    }
  | { type: 'FUTURE_TYPES_GO_HERE' }

interface QAComposerProps {
  composerJson: string
  onChoose: (r: QuickActionResult) => void
  onCancel: () => void
}

export default function QuickActionComposer({ composerJson, onChoose, onCancel }: QAComposerProps) {
  const data = JSON.parse(composerJson)
  switch (data.type) {
    case 'CROSS_SELL_SEARCH':
      return <CrossSellSearchModal options={data.crossSellOptions} onChoose={onChoose} onCancel={onCancel} />
    case 'FUTURE_TYPES_GO_HERE':
    default:
      throw new Error(`Unsupported: ${data.type}`)
  }
}
